<template>
  <div
    class="article"
    :class="[size ? 'article-' + size : '', { 'not-subscribe': notSubscribe }]"
  >
    <div v-if="tags" class="article__tags">
      <Tag
        v-if="classification"
        :text="classification"
        :color="'green'"
        :background="'gray'"
        :class="setTagColour(classification)"
      />
      <Tag
        v-for="(tag, index) in tags.filter((item, index) => index < 3)"
        :key="index"
        :text="tag.title"
        :color="'brightblue'"
        :background="'gray'"
        :link="setTagURL(tag)"
        :uuid="tag.uuid"
        :tid="tag.tid"
        :class="
          watchlistTags && watchlistTags.find((el) => tag.tid === el)
            ? 'brightblue'
            : null
        "
      />
    </div>

    <div class="article-bottom">
      <div v-if="download" class="article__download">
        <Download :file="download" />
      </div>
    </div>
    <div v-if="!file" class="article__title">
      <!-- eslint-disable vue/no-v-html -->
      <nuxt-link
        :to="link"
        class="article__title-link"
        :target="newTab ? '_blank' : '_self'"
        v-html="title"
      />
    </div>
    <div v-else>
      <a class="article__title-link" :href="file" v-html="title" />
    </div>
    <div v-if="desc && hasAccess" class="article__desc" v-html="desc" />
    <!-- eslint-enable vue/no-v-html -->
    <div v-if="desc && !hasAccess" class="article__desc unauthorised">
      {{ noAccessShort }}
    </div>
    <div v-if="date" class="article__date">
      <Date :text="date" :author="author" />
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
// import config from "../../nuxt.config";
import { noAccessShort } from "@/utils/constants";

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Article",
  components: {
    Tag: () => import("../elements/Tag"),
    Date: () => import("../elements/Date"),
  },
  props: {
    tags: {
      type: [Array, String],
      default: null,
    },
    reports: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    date: {
      type: [String, Number],
      default: null,
    },
    author: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: "/",
    },
    file: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    download: {
      type: String,
      default: null,
    },
    bigImage: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
    productAccess: {
      type: [Array, Number],
      default: null,
    },
    updates: {
      type: Boolean,
      default: false,
    },
    isPremiumReport: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "",
    },
    watchlistTags: {
      type: [Array, Number],
      default() {
        return [];
      },
    },
    classification: {
      type: String,
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
    filterTagsByVocabulary: {
      // Expects something similar to this: { vid: "jurisdictions", tid: 20 }
      type: Object,
      default: null,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    notSubscribe: false,
    noAccessShort,
  }),
  watch: {},
  mounted() {},
  methods: {
    setTagColour(col) {
      if (col === "Informative") {
        return "green";
      }

      if (col === "Indicative") {
        return "orange";
      }

      if (col === "Actionable") {
        return "dark-red-filled";
      }
    },
    setTagURL(link) {
      let newLink = "";
      // In some cases the vocabulary term is passed through as type and sometimes vocabulary, added in relation to PAYM-205
      let vocab = "";

      if (link.vocabulary && link.vocabulary.length > 0) {
        vocab = link.vocabulary;
      }

      if (link.type && link.type.length > 0) {
        vocab = link.type;
      }

      newLink = "/search?filter[" + vocab + "][]=" + link.tid;

      if (this.filterTagsByVocabulary !== null) {
        if (this.filterTagsByVocabulary.tid !== link.tid) {
          newLink += `&filter[${this.filterTagsByVocabulary.vid}][]=${this.filterTagsByVocabulary.tid}`;
        }
      }

      return newLink;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.article {
  margin-bottom: 3.2rem;
  position: relative;

  padding-bottom: 30px;

  &.border {
    .article__title {
      border-top: 1px solid $border;
      padding-top: 1rem;
    }
  }

  &-small {
    .article__title {
      @include below($md) {
        padding-right: 0.7em;
      }

      &-link {
        font-size: 1.8rem;
        line-height: 2.3rem;
      }
    }

    .article__desc {
      font-size: 1.4rem;
      line-height: 2rem;
    }

    .article__image {
      height: 17rem;
    }
  }

  &__tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
    //border-bottom: 1px solid #b1b3b3;
    margin-bottom: 1.2rem;

    &-more {
      margin-left: 1rem;
      font-weight: 600;
    }
  }

  &__report {
    display: flex;
    margin-bottom: 1.2rem;
  }

  &__title {
    margin-bottom: 1rem;

    &-link {
      color: $text_gray;
      font-size: 2.8rem;
      line-height: 3.3rem;
      font-weight: 700;
      text-decoration: none;
      transition: 0.3s ease-out;

      &:hover {
        color: $brightGreen;
      }

      @include below($md) {
        font-size: 2rem;
        line-height: 2.4rem;
      }
    }
  }

  &__desc {
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: $text_gray;
    margin-bottom: 1rem;
    padding-right: 1rem;
  }

  &__image {
    width: 100%;
    height: 27rem;
    display: block;
    margin-bottom: 1.6rem;
    transition: 0.3s ease-out;

    &:hover {
      opacity: 0.7;
    }

    &--big {
      height: 34rem;
    }

    @include below($md) {
      height: 20rem;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-bottom {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  mark {
    background-color: #eae6c5;
  }

  &__updates {
    .article__title-link {
      font-size: 1.4rem !important;
      line-height: 1.65rem;
    }
  }
}
</style>
